<template>
  <div>
    <!-- <form class="profile-form"> -->
      <h3 style="margin-bottom: 0;">Edit Professional Information</h3>
      <hr style="margin-bottom: 0px;">

      <label>Years of Experience (Must have at least 2 years of relevant experience)*</label>
      <!-- <small>Must have at least 2 years of relevant experience</small> -->
      <div class="form-check pl-4" v-for="(experienceOption, index) in experienceOptions" :key="'Experience'+index">
        <input class="form-check-input" type="radio" :value="experienceOption" v-model="experience">
        <label class="form-check-label ml-1" for="experienceRadios">
          {{ experienceOption }}
        </label>
      </div>
      <p class="required-message" v-if="!experience && submitClicked">This field is required.</p>

      <label style="">Position(s) Applying For* (Check all that apply)</label>
      <div class="form-check" v-for="(position, index) in positionsOptions" :key="'Position'+index">
        <input class="form-check-input" type="checkbox" :value="position" v-model="positions"/>
        <label class="form-check-label">{{ position }}</label>
      </div>
      <p class="required-message" v-if="!positions.length && submitClicked">This field is required.</p>

      <label>Commitment*</label>
      <div class="form-check pl-4" v-for="(commitmentOption, index) in commitmentOptions" :key="'Commitment'+index">
        <input class="form-check-input" type="radio" :value="commitmentOption" v-model="commitment">
        <label class="form-check-label ml-1" for="commitmentRadios">
          {{ commitmentOption }}
        </label>
      </div>
      <div v-if="commitment == 'Short Term (1 year or less)'">
        <label style="">Please explain why you are choosing short term (most of our positions are long term)</label>
        <input type="text" class="form-control" v-model="commitmentExplanation">
      </div>
      <p class="required-message" v-if="!commitment && submitClicked">This field is required.</p>

      <label style="">Availability* (Check all that apply)</label>
      <div class="form-check" v-for="(availabilityOption, index) in availabilityOptions" :key="'Availability'+index">
        <input class="form-check-input" type="checkbox" :value="availabilityOption" v-model="availability"/>
        <label class="form-check-label">{{ availabilityOption }}</label>
      </div>
      <p class="required-message" v-if="!availability.length && submitClicked">This field is required.</p>

      <label style="">Ideal Schedule* (Please note how many hours you would like)</label>
      <input type="text" class="form-control" v-model="schedule">
      <p class="required-message" v-if="!schedule && submitClicked">This field is required.</p>

      <label style="">Fluent in any other languages?*</label>
      <input type="text" class="form-control" v-model="languages">
      <p class="required-message" v-if="!languages && submitClicked">This field is required.</p>

      <label style="">Why did your last position end?*</label>
      <textarea rows="4" class="form-control" v-model="whyEnd"></textarea>
      <p class="required-message" v-if="!whyEnd && submitClicked">This field is required.</p>

      <div class="row">
        <div class="col-lg-6">
          <label style="">Pay range per hour*</label>
          <input type="text" class="form-control" v-model="payRange">
          <p class="required-message" v-if="!payRange && submitClicked">This field is required.</p>
        </div>
        <div class="col-lg-6">
          <label>Start Date*</label>
          <datepicker class="form-control" v-model="startDate" :disabled-dates="disabledDates" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
          <p class="required-message" v-if="!startDate && submitClicked">This field is required.</p>
        </div>
      </div>

      <label>Do you have a valid Driver's License and Car?*</label>
      <div class="form-check pl-4" v-for="(drivingStatusOption, index) in drivingStatuses" :key="'DrivingStatus'+index">
        <input class="form-check-input" type="radio" :value="drivingStatusOption" v-model="drivingStatus">
        <label class="form-check-label ml-1" for="drivingstatusRadios">
          {{ drivingStatusOption }}
        </label>
      </div>
      <p class="required-message" v-if="!drivingStatus && submitClicked">This field is required.</p>

      <label>Are you CPR and First Aid certified?*</label>
      <div class="form-check pl-4" v-for="(certificationStatusOption, index) in certificationStatuses" :key="'certificationStatusOption'+index">
        <input class="form-check-input" type="radio" :value="certificationStatusOption" v-model="certificationStatus">
        <label class="form-check-label ml-1" for="certificationStatusRadios">
          {{ certificationStatusOption }}
        </label>
      </div>
      <p class="required-message" v-if="!certificationStatus && submitClicked">This field is required.</p>

      <label>Are you up to date on vaccinations?*</label>
      <div class="form-check pl-4" v-for="(vaccinationStatusOption, index) in vaccinationStatuses" :key="'vaccinationStatus'+index">
        <input class="form-check-input" type="radio" :value="vaccinationStatusOption" v-model="vaccinationStatus">
        <label class="form-check-label ml-1" for="vaccinationStatusRadios">
          {{ vaccinationStatusOption }}
        </label>
      </div>
      <p class="required-message" v-if="!vaccinationStatus && submitClicked">This field is required.</p>

      <label style="">OK with pets in the home? (Check all that apply)</label>
      <div class="form-check" v-for="(petsOption, index) in petsOptions" :key="'petsOption'+index">
        <input class="form-check-input" type="checkbox" :value="petsOption" v-model="pets"/>
        <label class="form-check-label">{{ petsOption }}</label>
      </div>
      <!-- <p class="required-message" v-if="!positions.length && submitClicked">This field is required.</p> -->

      <label style="">Ok with travel? (Check all that apply)</label>
      <div class="form-check" v-for="(travelOption, index) in travelOptions" :key="'travelOption'+index">
        <input class="form-check-input" type="checkbox" :value="travelOption" v-model="travel"/>
        <label class="form-check-label">{{ travelOption }}</label>
      </div>
      <!-- <p class="required-message" v-if="!positions.length && submitClicked">This field is required.</p> -->

      <label>Are you legally able to work in the United States?*</label>
      <div class="form-check pl-4" v-for="(yesNoOption, index) in yesNoOptions" :key="'yesNoOption1'+index">
        <input class="form-check-input" type="radio" :value="yesNoOption" v-model="legalStatus">
        <label class="form-check-label ml-1" for="yesNoOptionsRadios">
          {{ yesNoOption }}
        </label>
      </div>
      <p class="required-message" v-if="!legalStatus && submitClicked">This field is required.</p>

      <label>Are you comfortable being paid legally?*</label>
      <div class="form-check pl-4" v-for="(yesNoOption, index) in yesNoOptions" :key="'yesNoOption2'+index">
        <input class="form-check-input" type="radio" :value="yesNoOption" v-model="legalPay">
        <label class="form-check-label ml-1" for="yesNoOptionsRadios">
          {{ yesNoOption }}
        </label>
      </div>
      <p class="required-message" v-if="!legalPay && submitClicked">This field is required.</p>

      <label style="">Do you have a valid Social Security Number?*</label>
      <input type="text" class="form-control" v-model="socialSecurity">
      <p class="required-message" v-if="!socialSecurity && submitClicked">This field is required.</p>

      <hr>
      <button class="mylisting-button dark-button" style="display: block; margin-left: auto;" @click.prevent="save()">Save</button>
    <!-- </form> -->
  </div>
</template>

<script>
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker

export default {
  props: ['user'],
  components: {
    Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
    // References,
  },
  data() {
    return {
      // positions: [],
      // positionsOptions: [],
      // license: false,
      // // booleanSelector1: false,
      // vehicle: '',
      // accidents: false,
      // // booleanSelector2: false,
      // accidentExplanation: '',
      // ages: [],
      // agesOptions: [],
      // experiences: [],
      // experiencesOptions: [],
      // otherExperience: '',
      // comfortableWith: [],
      // comfortableWithOptions: [],
      // languages: '',

      // preferredComm: '',
      // preferredComms: [],
      // commOptions: ['Email', 'SMS'],

      // highSchool: '',
      // graduated: false,
      // postSecondary: false,
      // degree: '',

      experience: '',
      positions: [],
      commitment: '',
      commitmentExplanation: '',
      availability: [],
      schedule: '',
      languages: '',
      whyEnd: '',
      payRange: '',
      startDate: null,
      drivingStatus: '',
      certificationStatus: '',
      vaccinationStatus: '',
      pets: [],
      travel: [],
      legalStatus: '',
      legalPay: '',
      socialSecurity: '',
      experienceDescription: '',
    }
  },
  computed: {
    disabledDates() {
      // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
      // https://www.npmjs.com/package/vuejs-datepicker#usage
      let today = new Date()
      let disabledDates = {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      }
      return disabledDates
    },
  },
  created() {
    // this.positionsOptions = this.$store.getters.positions
    // this.agesOptions = this.$store.getters.ages
    // this.experiencesOptions = this.$store.getters.experiences
    // this.comfortableWithOptions = this.$store.getters.comfortableWith

    // this.positions = this.user.preferences
    // // this.preferredComm = this.user.selector2
    // this.preferredComms = this.user.preferences3
    // this.license = this.user.boolean_selector1
    // this.vehicle = this.user.text2
    // this.accidents = this.user.boolean_selector2
    // this.accidentExplanation = this.user.text3
    // this.ages = this.user.skills
    // this.experiences = this.user.skills2
    // this.otherExperience = this.user.text5
    // this.comfortableWith = this.user.skills3
    // this.languages = this.user.text4

    // this.highSchool = this.user.text10
    // this.graduated = this.user.boolean_selector4
    // this.postSecondary = this.user.boolean_selector5
    // this.degree = this.user.text11

    this.experienceOptions = this.$store.getters.experienceOptions
    this.positionsOptions = this.$store.getters.positions
    this.commitmentOptions = this.$store.getters.commitmentOptions
    this.availabilityOptions = this.$store.getters.availabilityOptions
    this.drivingStatuses = this.$store.getters.drvingStatuses
    this.certificationStatuses = this.$store.getters.certificationStatuses
    this.vaccinationStatuses = this.$store.getters.vaccinationStatuses
    this.petsOptions = this.$store.getters.petsOptions
    this.travelOptions = this.$store.getters.travelOptions
    this.yesNoOptions = this.$store.getters.yesNoOptions

    this.experience = this.user.selector1
    this.positions = this.user.sectors
    this.commitment = this.user.selector2
    this.commitmentExplanation = this.user.text2
    this.availability = this.user.preferences
    this.schedule = this.user.text3
    this.languages = this.user.text4
    this.whyEnd = this.user.text5
    this.payRange = this.user.text6
    if (this.user.available_date) {
      this.startDate = new Date(this.user.available_date)
    }
    this.drivingStatus = this.user.selector3
    this.certificationStatus = this.user.selector4
    this.vaccinationStatus = this.user.selector5
    this.pets = this.user.preferences2
    this.travel = this.user.preferences3
    this.legalStatus = this.user.selector6
    this.legalPay = this.user.selector7
    this.socialSecurity = this.user.text7
    this.experienceDescription = this.user.text8
  },
  methods: {
    save() {
      let startDate = null
      if (this.startDate) {
        startDate = new Date(this.startDate)
        startDate = this.dateInDjangoFormat(this.startDate)
      }

      axios.patch('/api/people/'.concat(this.user.id.toString()).concat('/'), {
        selector1: this.experience,
        sectors: this.positions,
        selector2: this.commitment,
        text2: this.commitmentExplanation,
        preferences: this.availability,
        text3: this.schedule,
        text4: this.languages,
        text5: this.whyEnd,
        text6: this.payRange,
        available_date: startDate,

        selector3: this.drivingStatus,
        selector4: this.certificationStatus,
        selector5: this.vaccinationStatus,
        preferences2: this.pets,
        preferences3: this.travel,
        selector6: this.legalStatus,
        selector7: this.legalPay,
        text7: this.socialSecurity,

        text8: this.experienceDescription,
      })
        .then(res => {
          // this.$emit('professionalInfoSaved')
          this.$emit('infoSaved')
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/ProfessionalInfoForm.vue